export default "__VITE_ASSET__ChWhfEl2__"